export enum RoleEnum {
  SuperAdmin = 'SuperAdmin',
  TeamAdmin = 'TeamAdmin',
  SuperUser = 'SuperUser',
  User = 'User',
}

export enum DisplayRoleEnum {
  SuperAdmin = 'Tenant Admin',
  TeamAdmin = 'Team Admin',
  SuperUser = 'Super User',
  User = 'User',
}
